import $ from 'jquery';

$(document).ready(function() {
  $('.faq-item-answer__link.opened').on('click', function() {
    $(this)
      .parent('.faq-item-answer__block-show')
      .toggleClass('active');
    if ($('.faq-item-answer__block-show').hasClass('active')) {
      $(this)
        .closest('.faq-item-answer')
        .find('.faq-item-answer__text')
        .css({
          'max-height': '100%',
          overflow: 'initial'
        });
    } else {
      $(this)
        .closest('.faq-item-answer')
        .find('.faq-item-answer__text')
        .css({
          'max-height': '111px',
          transition: 'none',
          overflow: 'hidden'
        });
    }
  });

  $('[data-type-question]').on('click', (e) => {
    const currentType = $(e.currentTarget).attr('data-type-question');
    $('[name="clicked_button"]').val(currentType);
  });

  $('#for_add_faq_page').submit((e) => {
    e.preventDefault();
    
    let data = {
      action: 'faq_add',
      question: $(e.currentTarget).find('#faq_question').val(),
      name: $(e.currentTarget).find('#question-first-name').val(),
      code: $('#faq_code').val() 
    };
    
    $.post(ajaxurl, data, (response) => {
    
      if(response === 'success') {
        $.fancybox.open({
          src: '#thxQuestionAdded-window',
          closeExisting: true,
          smallBtn: false,
          toolbar: false,
          touch: false,
        });
      } else {
        alert(response);
      }
    });

    return false;
  });

  $('#set_faq_code').on('submit', (e) => {
    e.preventDefault();

    const currentType = $('[name="clicked_button"]').val();
    const $errorText = $(e.currentTarget).find('.error-box');
    $errorText.hide();

    let data = {
      code: $(e.currentTarget).find('input[name="code"]').val(),
      action: 'update_code_for_user'
    };

    $.post(ajaxurl, data, (response) => {
      if(response === 'code_not_found') {
        $errorText.show();
      } else if (response === 'success') {
        let idPopupForOpening = '#addQuestion-window';

        if(currentType === 'phone') {
          idPopupForOpening = '#phone-consultation';
        }
        
        $.fancybox.open({
          src: idPopupForOpening,
          closeExisting: true,
          smallBtn: false,
          toolbar: false,
          touch: false,
        });
      }
    });
  });

  $('.q-answer__code-row .mailing__form-input').on('focus', e => {
    let $this = $(e.currentTarget);

    $this.siblings('.q-answer__code-placeholder').addClass('hide');
  });

  $('.q-answer__code-row .mailing__form-input').on('blur', e => {
    let $this = $(e.currentTarget);

    if ($this.val() < 1) {
      $this.siblings('.q-answer__code-placeholder').removeClass('hide');
    }
  });
});
